export enum InvestigationApprovalPath {
	Execute = 1,
	RaiseToMinister = 2,
}
